import { FinancialDocumentListItem } from "@common/types/financialDocument";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";

export interface FinancialDocumentsTableCallbacks {
    onDocumentClick?: (document?: FinancialDocumentListItem) => void;
}

export interface FinancialDocumentsTableOptions {
    readonly?: boolean;
}

export const useIsFinancialDocumentsTableReadonly = (table: {
    options: { meta?: object };
}) =>
    useViewTableMeta<
        FinancialDocumentsTableCallbacks,
        FinancialDocumentsTableOptions
    >(table).options?.readonly ?? false;
